import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import Download from 'components/download.js';
import * as MobileActions from 'actions/index.ts';
import EnumService from 'services/enum2';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import OrderService from 'services/order';
import CompanyService from 'services/company2';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import { withStyles } from '@material-ui/core/styles';
import CommonFns from 'functions/common.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';

/*
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Fdetail%2F91904378%2F1016329175467075&response_type=code&scope=snsapi_base&state=123#wechat_redirect

https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx69332f4727b14d05&redirect_uri=https%3A%2F%2Fconsole.xiekeyun.com%2Fmp%2Fsale%2Fcustomer%2Forder%2Fdetail%2F30252802%2F1015402800009858&response_type=code&scope=snsapi_base&state=123#wechat_redirect

*/
const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  }
});
function OrderChangeDetail(props) {
  const Config = {
    sale: {
      title: '客户变更详情',
      apiPath: '/customerChange/detail',
      enumMainKey: 'B02_co_Status',
      receiveStatusKey: 'B02_Is_Contain_Tax',
      companyCodeKey: 'customerCode',
      companyNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        }
      ],
      idField: 'pocXkNo'
    },
    purchase: {
      title: '采购变更详情',
      apiPath: '/change/detail',
      enumMainKey: 'B02_co_Status',
      receiveStatusKey: 'B02_Is_Contain_Tax',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        }
      ],
      idField: 'pocXkNo',
      wfmCode: '1048'
    }
  };

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    isOpenOrgFlag,
    self
  } = useDetail(props, config);

  const [canResponse, setCanResponse] = useState(false);
  const { state, dispatch } = useContext(ActionContext);
  const [unitNum, setUnitNum] = useState({});

  //处理详情数据
  self.afterGetDetail = function (data) {
    //多角订单账款方不答交客户变更单
    setCanResponse(
      data.poOrder &&
        [null, undefined, 0, 2].includes(data.poOrder.multiRelationSourceType)
    );
    //重新组装答交信息，便于模板显示
    let replyList = data.answer ? data.answer.lineList : [];
    data.lineList.forEach((item, i) => {
      let arr = [];
      replyList.forEach(reply => {
        if (reply.lineNo === item.poLineNo) {
          arr.push(reply);
        }
      });
      item.replyList = arr;
      Util.genExtendFields(item.orderLine || {});
      let isContainTax = item.isContainTax;
      item.diff = []; //是否有差异
      item.diff[0] = item.changedExpectedDate !== item.expectedDate;
      item.diff[1] = item.changedPurchaseQty !== item.purchaseQty;
      item.diff[2] =
        (isContainTax && item.changedTaxPrice !== item.taxPrice) ||
        (!isContainTax && item.changedPrice !== item.price);
      item.diff[3] =
        (isContainTax && item.changedTaxLineAmount !== item.taxLineAmount) ||
        (!isContainTax && item.changedLineAmount !== item.lineAmount);
    });
    // 采购类型
    if (data.poOrder) {
      EnumService.getValue('B02_Purchase_Type', data.poOrder.purchaseType).then(
        value => {
          data.purchaseTypeName = value;
          setDetail(data);
        }
      );
    }

    EnumService.getValue(config.enumMainKey, data.status).then(value => {
      data.statusName = value;
      setDetail(data);
    });
    EnumService.getValue(
      config.receiveStatusKey,
      data.changedIsContainTax
    ).then(value => {
      data.changedIsContainTaxName = value;
      setDetail(data);
    });
    //小数位获取
    let currCompanyCode = !self.isPurchase ? data.customerCode : companyCode;
    CompanyService.getDecimalPlaceByCodes(currCompanyCode).then(rs => {
      let obj = {};
      for (let code in rs) {
        obj[code] = rs[code];
      }
      setUnitNum(obj);
    });

    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  /** 采购方操作 begin **/

  //同意
  async function agree() {
    let postbody = {
      companyCode: companyCode,
      poXkNo: detail.poXkNo,
      pocXkNo: self.id
    };
    OrderService.agreeChangeOrder(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //退回
  async function handleReject() {
    let postbody = {
      companyCode: companyCode,
      pocXkNo: self.id
    };
    OrderService.rejectChangeOrder(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  /** 采购方操作 end **/

  //客户订单确认
  function nodiffAnswerChange() {
    let postbody = {
      companyCode: companyCode,
      pocXkNos: [self.id]
    };
    OrderService.customerChangeConfirm(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //路由跳转
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">采购日期</span>
                  <div className="field-value">
                    {detail.poOrder && (
                      <span>{formatDate(detail.poOrder.erpPurchaseDate)}</span>
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">变更日期</span>
                  <div className="field-value">
                    {formatDate(detail.erpChangeDate)}
                  </div>
                </li>
                <li>
                  <span className="field-label">变更单状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('B02_co_Status', detail.status)
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                        onComplete={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
                {!self.isPurchase && (
                  <li>
                    <span className="field-label">客户</span>
                    <div className="field-value">
                      {detail.poOrder && (
                        <span>
                          {detail.poOrder.innerCustomerName}(
                          {detail.poOrder.innerCustomerCode})
                        </span>
                      )}
                    </div>
                  </li>
                )}
                {self.isPurchase && (
                  <li>
                    <span className="field-label">供应商</span>
                    <div className="field-value">
                      {detail.compVendor && (
                        <span>
                          {detail.compVendor.innerVendorName}(
                          {detail.compVendor.innerVendorCode})
                        </span>
                      )}
                    </div>
                  </li>
                )}

                <li>
                  <span className="field-label">采购订单</span>
                  <div className="field-value">{detail.poErpNo}</div>
                </li>
                <li>
                  <span className="field-label">平台单号</span>
                  <div className="field-value">{detail.poXkNo}</div>
                </li>
                <li>
                  <span className="field-label">采购类型</span>
                  <div className="field-value">{detail.purchaseTypeName}</div>
                </li>
                <li>
                  <span className="field-label">交易条件</span>
                  <div className="field-value">{detail.conditionName}</div>
                </li>
                <li>
                  <span className="field-label">交易币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">采购员</span>
                  <div className="field-value">
                    {detail.poOrder && <span>{detail.poOrder.buyerName}</span>}
                  </div>
                </li>
                <li>
                  <span className="field-label">交易税别</span>
                  <div className="field-value">{detail.taxName}</div>
                </li>
                <li>
                  <span className="field-label">付款条件</span>
                  <div className="field-value">
                    {detail.payWayCode}-{detail.payWayName}
                  </div>
                </li>
                {(isOpenOrgFlag ||
                  [2, 3, 4].includes(detail.sourceType) ||
                  detail.sourceSystem === 2) && (
                  <li>
                    <span className="field-label">采购组织</span>
                    <div className="field-value">
                      {detail.erpOrgCode}-{detail.erpOrgName}
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>条款、备注、物流信息等</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">订单备注</span>
                  <div className="field-value">{detail.changedRemark}</div>
                </li>
                <li>
                  <span className="field-label">补充条款</span>
                  <div className="field-value">
                    {detail.poOrder && <span>{detail.poOrder.agreement}</span>}
                  </div>
                </li>
                <li>
                  <span className="field-label">物流方式</span>
                  <div className="field-value">
                    {detail.poOrder && (
                      <span>{detail.poOrder.logisticsName}</span>
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">收货地址</span>
                  <div className="field-value">{detail.changedAddressInfo}</div>
                </li>
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign2 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(2);
            }}
          >
            {moreSign2 && '更多'}
            {!moreSign2 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>产品明细</label>
          </div>
          <div className="details-item-content">
            {detail.lineList?.map((item, index) => (
              <div
                className="content-line line-list-item"
                key={String(item.id) + index}
              >
                <div className="line-list-item-title">
                  {item.orderLine && (
                    <span>
                      项次{item.orderLine.poLineNoShow || item.orderLine.lineNo}
                    </span>
                  )}
                </div>

                <ul className="field-list">
                  <li>
                    <span className="field-label">产品编码</span>
                    <div className="field-value">{item.changedProductCode}</div>
                  </li>
                  <li>
                    <span className="field-label">产品名称</span>
                    <div className="field-value">{item.changedProductName}</div>
                  </li>
                  <li>
                    <span className="field-label">产品规格</span>
                    <div className="field-value">
                      {item.changedProductScale}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">单价</span>
                    <div className="field-value">
                      {item.isContainTax
                        ? formatNumber(
                            item.taxPrice,
                            unitNum.Price_Decimal_Place
                          )
                        : formatNumber(item.price, unitNum.Price_Decimal_Place)}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">金额</span>
                    <div className="field-value">
                      <span className="blue">
                        {item.isContainTax
                          ? formatNumber(
                              item.taxLineAmount,
                              unitNum.Amount_Decimal_Place
                            )
                          : formatNumber(
                              item.lineAmount,
                              unitNum.Amount_Decimal_Place
                            )}
                      </span>
                    </div>
                  </li>
                  <li>
                    <span className="field-label">交货日期</span>
                    <div className="field-value">
                      {formatDate(item.expectedDate)}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">采购数量</span>
                    <div className="field-value">
                      {formatNumber(
                        item.purchaseQty,
                        unitNum.Quantity_Decimal_Place
                      )}{' '}
                      {item.changedPurchaseUnitCode}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">计价数量</span>
                    <div className="field-value">
                      {formatNumber(
                        item.valuationQty,
                        unitNum.Quantity_Decimal_Place
                      )}{' '}
                      {item.changedValuationUnitCode}
                    </div>
                  </li>
                  {item.remark && (
                    <li className="single">
                      <span className="field-label">备注</span>
                      <div className="field-value">{item.remark}</div>
                    </li>
                  )}
                  {item.orderLine &&
                    item.orderLine.printExtendFields !== '' && (
                      <li className="single">
                        <span className="field-label">采购说明</span>
                        <div className="field-value">
                          {item.orderLine.printExtendFields}
                        </div>
                      </li>
                    )}
                </ul>
                <div className="order-detail-more">
                  <ul className="field-list">
                    <li>
                      <span className="field-label">变更信息</span>
                      <div className="field-value"></div>
                    </li>
                    <li>
                      <span className="field-label">单价</span>
                      <div className="field-value">
                        <span className={item.diff[2] ? 'red' : ''}>
                          {item.isContainTax
                            ? formatNumber(
                                item.changedTaxPrice,
                                unitNum.Price_Decimal_Place
                              )
                            : formatNumber(
                                item.changedPrice,
                                unitNum.Price_Decimal_Place
                              )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">金额</span>
                      <div className="field-value">
                        <span className={item.diff[3] ? 'red' : ''}>
                          {item.isContainTax
                            ? formatNumber(
                                item.changedTaxLineAmount,
                                unitNum.Amount_Decimal_Place
                              )
                            : formatNumber(
                                item.changedLineAmount,
                                unitNum.Amount_Decimal_Place
                              )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">交货日期</span>
                      <div className="field-value">
                        <span className={item.diff[0] ? 'red' : ''}>
                          {formatDate(item.changedExpectedDate)}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">采购数量</span>
                      <div className="field-value">
                        <span className={item.diff[1] ? 'red' : ''}>
                          {formatNumber(
                            item.changedPurchaseQty,
                            unitNum.Quantity_Decimal_Place
                          )}
                        </span>
                      </div>
                    </li>
                    <li>
                      <span className="field-label">计价数量</span>
                      <div className="field-value">
                        <span
                          className={
                            item.changedValuationQty !== item.valuationQty
                              ? 'red'
                              : ''
                          }
                        >
                          {formatNumber(
                            item.changedValuationQty,
                            unitNum.Quantity_Decimal_Place
                          )}
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                {!self.isPurchase &&
                  item.replyList &&
                  item.replyList.length > 0 && (
                    <div>
                      {item.replyList.map((reply, replyIndex) => (
                        <div
                          className="order-detail-more"
                          key={String(reply.id) + replyIndex}
                        >
                          <ul className="field-list bc-pink">
                            <li>
                              <span className="field-label">答交信息</span>
                              <div className="field-value"></div>
                            </li>

                            <li>
                              <span className="field-label">单价</span>
                              <div className="field-value">
                                {item.isContainTax
                                  ? formatNumber(
                                      reply.vTaxPrice,
                                      unitNum.Price_Decimal_Place
                                    )
                                  : formatNumber(
                                      reply.vPrice,
                                      unitNum.Price_Decimal_Place
                                    )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">金额</span>
                              <div className="field-value">
                                {item.isContainTax
                                  ? formatNumber(
                                      reply.vTaxLineAmount,
                                      unitNum.Amount_Decimal_Place
                                    )
                                  : formatNumber(
                                      reply.vLineAmount,
                                      unitNum.Amount_Decimal_Place
                                    )}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">交货日期</span>
                              <div className="field-value">
                                {formatDate(reply.vExpectedDate)}
                              </div>
                            </li>
                            <li>
                              <span className="field-label">采购数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  reply.vPurchaseQty,
                                  unitNum.Quantity_Decimal_Place
                                )}
                              </div>
                            </li>
                          </ul>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            ))}
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>合计</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">订单数量</span>
                  <div className="field-value">
                    {formatNumber(
                      detail.changedTotalCount,
                      unitNum.Quantity_Decimal_Place
                    )}
                  </div>
                </li>
                <li>
                  <span className="field-label">订单金额</span>
                  <div className="field-value">
                    {detail.isContainTax
                      ? formatNumber(
                          detail.changedProductTaxTotal,
                          unitNum.Amount_Decimal_Place
                        )
                      : formatNumber(
                          detail.changedProductTotal,
                          unitNum.Amount_Decimal_Place
                        )}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {self.isPurchase &&
        User.checkAuth('10010202') &&
        [4].includes(detail.status) && (
          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={() => {
                agree();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              同意
            </Button>
            <Button
              type="default"
              onClick={() => {
                handleReject();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              退回
            </Button>
          </div>
        )}

      {!self.isPurchase &&
        User.checkAuth('20010102') &&
        canResponse &&
        [0, 2].includes(detail.status) && (
          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={() => {
                nodiffAnswerChange();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              无差异确认
            </Button>
          </div>
        )}

      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

OrderChangeDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(OrderChangeDetail));
